import { OnInit, Directive } from '@angular/core';
import { BaseComponent } from './base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { DrCurrencyFormat, DrI18nService } from '@app/core/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbsService } from '@app/core/services/breadcrumbs.service';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/core/authentication';
import { User } from '@app/shared/models/user';
import { CurrencyService } from '@app/core/services/currency.service';
import { NotificationService } from '@app/core/services/notification.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Directive()
export abstract class BaseWithBundleComponent extends BaseComponent implements OnInit {

  protected router: Router;
  protected route: ActivatedRoute;
  protected dialog: MatDialog;
  protected drI18nService: DrI18nService;
  protected translateService: TranslateService;
  protected breadcrumbsService: BreadcrumbsService;
  protected authenticationService: AuthenticationService;
  protected currencyService: CurrencyService;
  protected notificationService: NotificationService;

  get currentUser(): User {
    return this.authenticationService.currentUserValue;
  }

  get currency(): DrCurrencyFormat {
    return this.currencyService.activeCurrency;
  }

  protected constructor(protected componentServiceBundle: ComponentServiceBundle) {
    super();
    this.router = this.componentServiceBundle.router;
    this.route = this.componentServiceBundle.route;
    this.dialog = this.componentServiceBundle.dialog;
    this.drI18nService = this.componentServiceBundle.drI18nService;
    this.translateService = this.componentServiceBundle.translateService;
    this.breadcrumbsService = this.componentServiceBundle.breadcrumbsService;
    this.authenticationService = this.componentServiceBundle.authenticationService;
    this.currencyService = this.componentServiceBundle.currencyService;
    this.notificationService = this.componentServiceBundle.notificationService;
  }

  public ngOnInit() {
    super.ngOnInit();
  }

  protected buildBreadcrumb(): void {}

  protected showSimpleInfoDialog(title: string, text: string | string[], width?: string): Observable<any> {
    return this.notificationService.showSimpleInfoDialog(title, text, width);
  }

  protected showSimpleConfirmDialog(title: string, text: string | string[], width?: string): Observable<any> {
    return this.notificationService.showSimpleConfirmDialog(title, text, width);
  }

  protected showSimpleConfirmSnackbar(message: string, duration = 3000): void {
    return this.notificationService.showSimpleConfirmSnackbar(message, duration);
  }

  protected showSimpleErrorSnackbar(message: string = marker('common.label.error_has_occurred'), duration = 5000): void {
    return this.notificationService.showSimpleErrorSnackbar(message, duration);
  }
}
